// extracted by mini-css-extract-plugin
module.exports = {"link":"link__3IDC0","signInForgotPasswordContainer":"signInForgotPasswordContainer__3qH3n","signInForgotPassword":"signInForgotPassword__1HHNf"};